import React from 'react';
import {
  columnCreatedOn,
  columnAssignee,
  columnWorkflowName,
  columnRequest,
  columnRequestLink,
  columnDataset,
  columnDatasetLink,
  columnRequester,
  hasColumn,
} from '@/constants/fields';
import TableSortedColumn from '@/components/table/TableSortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import Events from '../hooks/events';
import Selectors from '../hooks/selectors';

const TasksTableColumns = ({ category, items, columns }) => {
  const { orderBy, singleSorting } = Selectors.useTasksTableColumns({ category });
  const onOrderByColumn = Events.useToggleTaskColumnOrderBy(category);

  return (
    <NameDescriptionColumns
      category={category}
      columns={columns}
      entity="task"
      items={items}
      onOrderByColumn={onOrderByColumn}
      orderBy={orderBy}
      singleSorting={singleSorting}
    >
      {hasColumn(columns, columnAssignee) && (<UnsortedColumn columnId={columnAssignee} />)}
      {hasColumn(columns, columnCreatedOn) && (
        <TableSortedColumn
          name={columnCreatedOn}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting={singleSorting}
          sortable
        />
      )}
      {hasColumn(columns, [columnRequest, columnRequestLink]) && (<UnsortedColumn columnId={columnRequest} />)}
      {hasColumn(columns, [columnDataset, columnDatasetLink]) && (<UnsortedColumn columnId={columnDataset} />)}
      {hasColumn(columns, columnRequester) && (<UnsortedColumn columnId={columnRequester} />)}
      {hasColumn(columns, columnWorkflowName) && (<UnsortedColumn columnId={columnWorkflowName} />)}
    </NameDescriptionColumns>
  );
};

export default TasksTableColumns;
